import { render, staticRenderFns } from "./swimming-pool.vue?vue&type=template&id=54ddaccc&scoped=true"
import script from "./swimming-pool.vue?vue&type=script&lang=js"
export * from "./swimming-pool.vue?vue&type=script&lang=js"
import style0 from "./swimming-pool.vue?vue&type=style&index=0&id=54ddaccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ddaccc",
  null
  
)

export default component.exports